'use client'

import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LuMapPin } from 'react-icons/lu'
import { Box } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import { Location } from '@leid/api-locations'

import { LeidButton } from 'components/ui/Buttons/Button'
import { ButtonServer } from 'components/ui/Buttons/Button/server'
import { getDirectionLink } from 'utils/locations'
import { normalizeUrl } from 'utils/normalizeUrl'

type Props = {
  masterArticle: Article | undefined
  relatedArticle: Article | undefined
  location?: Location
  leidButtons?: boolean
}

const ProductInfoButtons = ({ masterArticle, relatedArticle, location, leidButtons }: Props): JSX.Element => {
  const { t } = useTranslation()

  const getButton = (href: string, label: ReactNode, openNewTab?: boolean) => {
    if (leidButtons) {
      return (
        <LeidButton href={href} openNewTab={openNewTab}>
          {label}
        </LeidButton>
      )
    }
    return (
      <ButtonServer href={href} openNewTab={openNewTab}>
        {label}
      </ButtonServer>
    )
  }

  return (
    <>
      {masterArticle && (
        <Box marginBottom={5} width="100%">
          {getButton(`/articles/${normalizeUrl(masterArticle.title ?? '', masterArticle.id)}`, t('howToPickup'))}
        </Box>
      )}

      {relatedArticle && (
        <Box marginBottom={5} width="100%">
          {getButton(
            `/articles/${normalizeUrl(relatedArticle.title ?? '', relatedArticle.id)}`,
            t('productInstructions'),
          )}
        </Box>
      )}

      {location && (
        <Box marginBottom={5} width="100%">
          {
            (getButton(
              getDirectionLink(location),
              <>
                <LuMapPin size={20} />
                {t('getDirections')}
              </>,
            ),
            true)
          }
        </Box>
      )}
    </>
  )
}

export default ProductInfoButtons
